"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetNewPassword = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const notistack_1 = require("notistack");
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const mui_inputs_core_1 = require("@framework/mui-inputs-core");
const mui_page_layout_1 = require("@framework/mui-page-layout");
const mui_form_1 = require("@framework/mui-form");
const provider_user_1 = require("@framework/provider-user");
const provider_api_1 = require("@framework/provider-api");
const yup_rules_1 = require("@framework/yup-rules");
const validation_1 = require("./validation");
const buttons_1 = require("./buttons");
const SetNewPassword = () => {
    const user = (0, provider_user_1.useUser)();
    const api = (0, provider_api_1.useApi)();
    const isAuthenticated = user.isAuthenticated();
    const location = (0, react_router_dom_1.useLocation)();
    const state = location.state;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [policy, setPolicy] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        (0, yup_rules_1.fetchPasswordPolicy)(api.fetchJson)
            .then(nextPolicy => {
            if (!cancelled) {
                setPolicy(nextPolicy);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setPolicy(yup_rules_1.DEFAULT_PASSWORD_POLICY);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [api]);
    const handleApiError = (e, form) => {
        if (e.status === 400) {
            if (e.interlayerErrors?.length) {
                e.interlayerErrors.forEach(({ key }) => {
                    if (!key) {
                        return;
                    }
                    const fieldKey = (0, yup_rules_1.getPasswordFormFieldForErrorKey)(key, "newPassword", {
                        unauthorizedField: "currentPassword",
                    });
                    form.setError(fieldKey, { type: "custom", message: `form.validations.${key}` });
                });
            }
        }
        else if (e.status === 403) {
            if (e.interlayerErrors?.length) {
                e.interlayerErrors.forEach(({ key }) => {
                    (0, notistack_1.enqueueSnackbar)(formatMessage({ id: `snackbar.${key}` }), { variant: "error" });
                });
            }
        }
        else if (e.status) {
            (0, notistack_1.enqueueSnackbar)(formatMessage({ id: `snackbar.${e.message}` }), { variant: "error" });
        }
        else {
            console.error(e);
            (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.error" }), { variant: "error" });
        }
    };
    const handleSubmit = async (values, form) => {
        try {
            await user.setNewPassword({
                login: values.login,
                currentPassword: values.currentPassword,
                newPassword: values.newPassword,
            }, "/message/set-new-password-successful");
        }
        catch (e) {
            handleApiError(e, form);
        }
    };
    (0, react_1.useEffect)(() => {
        if (isAuthenticated) {
            void user.getProfile();
        }
    }, [isAuthenticated]);
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: 500,
            margin: "0 auto",
        }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, sm: 10, children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.guest.setNewPassword" }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: !policy, children: policy ? ((0, jsx_runtime_1.jsxs)(mui_form_1.FormWrapper, { showButtons: false, showPrompt: false, validationSchema: (0, validation_1.createSetNewPasswordValidationSchema)(policy), onSubmit: handleSubmit, initialValues: {
                            login: state?.login ?? user.profile?.login ?? "",
                            currentPassword: "",
                            newPassword: "",
                            confirmPassword: "",
                        }, testId: "SetNewPassword", children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "login", autoComplete: "username" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.PasswordInput, { name: "currentPassword", autoComplete: "current-password" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", color: "textSecondary", children: formatMessage({ id: "form.validations.currentPasswordHint" }) }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.PasswordInput, { name: "newPassword", autoComplete: "new-password" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.PasswordInput, { name: "confirmPassword", autoComplete: "new-password" }), (0, jsx_runtime_1.jsx)(buttons_1.SetNewPasswordButtons, {})] })) : null })] }) }));
};
exports.SetNewPassword = SetNewPassword;
//# sourceMappingURL=index.js.map